import React from 'react';
import { Section } from '../ui/Section';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <Section background="light-peach" containerSize="md" className="text-center" data-id="element-136">
      <motion.div className="bg-cream p-12 rounded-[3rem] border border-dusty-rose/30 inline-block shadow-sm max-w-2xl" whileHover={{
      scale: 1.01
    }} transition={{
      duration: 0.5
    }} data-id="element-137">
        <ShieldCheck className="w-16 h-16 text-warm-gold mx-auto mb-6 opacity-80" data-id="element-138" />
        <h2 className="text-3xl font-serif italic text-navy mb-6" data-id="element-139">
          Garantía de 7 días
        </h2>
        <p className="text-lg text-muted max-w-lg mx-auto font-light leading-relaxed" data-id="element-140">
          Probalo tranquila. Si no es para vos, te devolvemos el 100%. Sin
          vueltas.
        </p>
      </motion.div>
    </Section>;
}